import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { BaseModalProps } from './interfaces';
import { Container, Content, Header, HeaderTitle } from './styles';

const BaseModal: React.FC<BaseModalProps> = (props) => {
  const {
    title,
    children,
    containerStyle,
    contentStyle,
    headerStyle,
    HeaderContent,
  } = props;
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 1000px)' });

  return (
    <Container
      style={{
        ...containerStyle,
        ...(isMobile && { margin: '30px 0 80px 0', height: '80vh' }),
      }}
    >
      <Header style={headerStyle}>
        <HeaderTitle>{t(title || '')}</HeaderTitle>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 50,
            height: '100%',
          }}
        >
          {HeaderContent}
        </div>
      </Header>
      <Content style={contentStyle}>{children}</Content>
    </Container>
  );
};

export default BaseModal;
